import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { BeatLoader } from 'react-spinners';

import CRMLearningAcademy from '../component/pages/CRM';
import CRMLearningAcademyPublic from '../component/pages/CRM_public'
import PublicCertificateView from '../component/pages/PublicView';
import HomePage from '../component/pages/HomePage'
import Example from '../component/pages/testingapp/light_InvestigationRoom'
import AdvisorConsole from '../component/pages/Advisorconsole';

const CustomRoutes = () => {


  return (
      <BrowserRouter>
      <Suspense fallback={ <div style={{ position: 'fixed', top: '350px', left: '800px' }}>
      <BeatLoader color={'#123abc'} loading={true} size={10} />
    </div>}>
    
        <Routes>

          <Route path="/testingapp" element={<Example />} />
          <Route path="/" element={<HomePage />} />
          <Route path="courses/:academyid" element={<CRMLearningAcademy />} />
           <Route path="acourses/:academyid" element={<CRMLearningAcademyPublic />} />

          
          <Route path="verify/:publicid" element={<PublicCertificateView />} />

          <Route path="/advisorchat" element={<AdvisorConsole />} />
      
        </Routes>
        
        </Suspense>
        
      </BrowserRouter>
  )
}

export default CustomRoutes